import { AlertController } from '@ionic/angular/standalone';

/**
 * TEC-88/TEC-149: post-payment alert explaining which subscription days could not reserve
 * a seat ("No fue posible apartar tu lugar el…"). The message is built by the API
 * reservation sweep and travels as `reservation.message` on every subscription activation
 * response (store/update), regardless of payment method. No message → nothing to show.
 */
export async function presentReservationNotice(
  alertController: AlertController,
  reservation: { message?: string } | null | undefined
): Promise<void> {
  const message = reservation?.message;
  if (!message) {
    return;
  }

  const alert = await alertController.create({
    header: 'Suscripción activada',
    message,
    buttons: ['Entendido'],
  });
  await alert.present();
  await alert.onDidDismiss();
}
